import styled, { css } from 'styled-components';

export const Description = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.typography.body.fontSize};
    color: ${theme.colors.text[100]};
    text-align: center;
    padding-top: 120px;
    max-width: 600px;
    width: 100%;
  `}
`;
